import React, { useState, useEffect } from 'react';
import {
    Card,
    CardText,
    CardBody,
    CardTitle,
    CardHeader,
    CardFooter,
    Button,
    Row,
    Col
} from 'reactstrap';
import { tokenHeader, getUserToken, getUsers, dateFormat, getCurrentUser } from "../../services/user-service";

const Profile = (props) => {

    const [loaded, setLoaded] = useState(false);
    const [currentUser, setCurrentUser] = useState([]);

    var getCurrentUserData = () => {
        getCurrentUser().then((users) => {
            // console.log("users", users)
            setCurrentUser(users);
        });
    }

    useEffect(() => {
        if (!loaded) {
            getCurrentUserData()
            setLoaded(true);
        }
    });

    return (

        <div>

            {/* --------------------------------------------------------------------------------*/}
            {/* Row*/}
            {/* --------------------------------------------------------------------------------*/}
            {/* <h5 className="mb-3">Cards with Header and Footer</h5> */}

            <Row>
                {/* <Col sm="3"></Col> */}
                <Col sm="6">
                    {/* {currentUser.map(item => ( */}
                    <Card>
                        <CardHeader tag="h5">My Profile</CardHeader>
                        <CardBody>
                            <CardTitle>Name : </CardTitle><CardText>{currentUser.name}</CardText>
                            <CardTitle>Email : </CardTitle><CardText>{currentUser.email}</CardText>
                            {/* <CardText>{currentUser.status}</CardText> */}
                            <CardText>{currentUser.level}</CardText>
                            {/* <Button>Go somewhere</Button> */}
                        </CardBody>
                        <CardFooter className="text-muted"><b style={{color:'#3e5569'}}>Joining Date :</b> <span style={{color:'#3e5569'}}> {dateFormat(currentUser.createdAt)}</span></CardFooter>
                    </Card>
                    {/* ))} */}
                </Col>

                <Col sm="3"></Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Row*/}
            {/* --------------------------------------------------------------------------------*/}
            {/* --------------------------------------------------------------------------------*/}
            {/* End Inner Div*/}
            {/* --------------------------------------------------------------------------------*/}
        </div>

    );
}

export default Profile;


